export const POINTER_ID_TO_CAPTURED_TARGET_MAP: Map<number, EventTarget> = new Map();
